<template>
    <div class="homes no-trans" v-loading="loading">
        <div class="banners">
            <banners ref="banners" @handle_lvshi_add="handle_lvshi_add"></banners>
        </div>
        <div class="case_reviews_box">
            <case_reviews ref="case_reviews"></case_reviews>
           
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="6" ></hd_banner>
        </div>
        <div class="dharma_realm_box">
            <dharma ref="dharma"></dharma>
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="7"></hd_banner>
        </div>
        <div class="corporate_legal_affairs">
            <corporate_legal_affairs ref="corporate_legal_affairs"></corporate_legal_affairs>
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="8"></hd_banner>
        </div>
        <div class="lawyer_box">
            <lawyer_box ref="lawyer_box"  @handle_lvshi_add="handle_lvshi_add"></lawyer_box>
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="9"></hd_banner>
        </div>
        <div class="office_box">
            <office_box ref="office_box" @handle_lvsuo_add="handle_lvsuo_add"></office_box>
        </div>
        <agreement ref="agreement"  @handle_end="handle_end"></agreement>
        <lvshi_add ref="lvshi_add"  @handle_end="handle_end"></lvshi_add>
        
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
import banners from '@/components/index_home/banner.vue'//顶部banner
import case_reviews from '@/components/index_home/case_reviews.vue'//裁判点评
import dharma from '@/components/index_home/dharma.vue'//法界热点
import hd_banner from '@/components/index_home/hd_banner.vue'//活动图片
import corporate_legal_affairs from '@/components/index_home/corporate_legal_affairs.vue'//企业法务
import lawyer_box from '@/components/index_home/lawyer_box.vue'//进住律师
import office_box from '@/components/index_home/office_box.vue'//推荐事务所

import lvshi_add from '@/components/index_home/lvshi_add.vue'//入住律师
// import lvshi_add from '@/components/index_home/lvshi_add.vue'//入住律师

export default {
    components: {
        banners,
        case_reviews,
        dharma,
        hd_banner,
        corporate_legal_affairs,
        lawyer_box,
        office_box,
        lvshi_add

    },
    name: "homes",
    data() {
        return {
            loading: false,
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        // this.$refs.agreement.handle_open()

    },
    mounted(){
        //临时调取
        // this.$refs.agreement.handle_open()
    },
    methods: {
        //同意回调
        handle_end(){},
        // 律师入住回调
        handle_lvshi_add(){
            console.log('123123')
            this.$refs.lvshi_add.handle_open()
        },
        //律所入住回调
        handle_lvsuo_add(){
            this.$router.push({
                path:'/law_firms_add',
            })
        },



    },

}
</script>
<style scoped lang="less">
.homes {
    padding-bottom: 100px


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .homes.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;

        /deep/ .case_reviews_box.no-trans .case_reviews,
        /deep/ .dharma_realm_box.no-trans .dharma_realm,
        /deep/ .corporate_legal_affairs.no-trans .cla_felx,
        /deep/ .lawyer_box.no-trans .lawyers,
        /deep/ .office_box.no-trans .offices {
            padding-left: 16px;
            padding-right: 16px;
        }

        .mobile-heading() {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: nowrap;
            gap: 8px;
            height: auto;
            .lefts {
                display: flex;
                flex: 1 1 0;
                min-width: 0;
                flex-direction: column;
                align-items: flex-start;
                flex-wrap: nowrap;
                gap: 2px;
            }
            .title_text1, .lefts .title_text1 { font-size: 20px; line-height: 28px; }
            .title_text2, .lefts .title_text2 { font-size: 13px; line-height: 20px; margin: 0; }
            .title_img, .lefts .title_img { display: none; }
            .rights {
                display: flex;
                flex: 0 0 auto;
                flex-wrap: nowrap;
                gap: 8px;
                margin-left: auto;
                .btns1, .btns2 {
                    width: auto;
                    min-height: 44px;
                    margin: 0;
                    padding: 12px 10px;
                    font-size: 14px;
                    line-height: 20px;
                    white-space: nowrap;
                    border-radius: 4px;
                }
            }
        }
        /deep/ .case_reviews_box.no-trans .case_reviews > .title_box,
        /deep/ .dharma_realm_box.no-trans .dharma_realm > .title_box,
        /deep/ .corporate_legal_affairs.no-trans .cla_felx .cla_lefts > .title_box,
        /deep/ .corporate_legal_affairs.no-trans .cla_felx .cla_rights > .title_box,
        /deep/ .lawyer_box.no-trans .lawyers > .title_box,
        /deep/ .office_box.no-trans .offices > .title_box {
            .mobile-heading();
        }

        /deep/ .dharma_realm_box.no-trans .dharma_realm .dharma_cehck_list,
        /deep/ .corporate_legal_affairs.no-trans .cla_felx .cla_lefts .tab_box .tab_list {
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            gap: 0;
            min-width: 0;
            max-width: 100%;
            overflow-x: auto;
            overscroll-behavior-x: contain;
            scrollbar-width: thin;
            padding-top: 8px;
            .tab_list, .tab_item {
                flex: 0 0 auto;
                min-height: 44px;
                margin: 0;
                padding: 12px 14px 0;
                text-align: center;
                cursor: pointer;
                .tab_title, .item_text { font-size: 15px; line-height: 24px; white-space: nowrap; }
                .borders, .item_border { width: 100%; height: 3px; margin-top: 9px; }
                &:focus-visible { outline: 2px solid #377CFD; outline-offset: -2px; }
            }
        }
        /deep/ .corporate_legal_affairs.no-trans .cla_felx {
            gap: 24px;
            .cla_lefts .tab_box {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                gap: 12px;
                .tab_btns { align-self: flex-end; }
                .tab_btns .btns { width: auto; min-height: 44px; padding: 12px 16px; line-height: 20px; border-radius: 4px; }
            }
            .cla_rights .text_btns_box {
                align-items: center;
                justify-content: space-between;
                .btns_box { width: auto; height: auto; min-height: 44px; padding: 12px 16px; line-height: 20px; border-radius: 4px; }
            }
            .cla_rights .type_list {
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                gap: 0;
                .type_itme { width: 100%; min-height: 92px; padding: 12px 4px; }
                .type_itme2 { display: none; }
            }
        }
        /deep/ .dharma_realm_box.no-trans .dharma_realm .dharma_realm_flex {
            .lefts { width: 100%; gap: 16px; }
            .lefts .dharma_realm_new { margin: 0; }
            .lefts .dharma_realm_new .imgs { aspect-ratio: 16 / 9; overflow: hidden; }
            .lefts .dharma_realm_new .imgs img { height: 100%; object-fit: cover; }
            .lefts .dharma_realm_new .info_box .titles { font-size: 17px; line-height: 26px; }
        }
        /deep/ .lawyer_box.no-trans .lawyers .law_list_box {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 12px;
            align-items: stretch;
            .law_list {
                overflow: hidden;
                border-radius: 6px;
                background: #fff;
                .bg_img { aspect-ratio: 3 / 4; }
                .bg_img img { height: 100%; object-fit: cover; object-position: top; }
                .item_info_box {
                    background: #fff;
                    padding: 12px;
                    color: #333;
                    .item_name { font-size: 17px; color: #333; }
                    .item_zw .zw_text { font-size: 13px; color: #377CFD; }
                    .item_const { color: #666; font-size: 13px; line-height: 20px; }
                    .item_address { color: #666; font-size: 13px; margin-top: 8px; }
                }
            }
        }
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .homes.no-trans {
        /deep/ .lawyer_box.no-trans .lawyers .law_list_box { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        /deep/ .dharma_realm_box.no-trans .dharma_realm .dharma_realm_flex .lefts {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
}
</style>
